import { CalendarDotsIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const StartDate = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <CalendarDotsIcon size={Sizes[size]} {...rest} color={fill} />;
};

StartDate.displayName = 'StartDate';
